// React imports.
import React, { Component } from "react";
import { GraphType } from "../state";

const GraphTypes = ({ graphTypes, selectGraphType}) => (
  <div className="verticalList" >
    {(Object.values(graphTypes) as GraphType[])
      .filter(gt =>gt.graphTypeAvailable)
      .map(gt => (
        <label key={gt.code}>
          <input type="radio"
            name="rdoGraphTypes"
            value={gt.code}
            onChange={e => selectGraphType(gt.code)}
            checked={gt.graphTypeSelected}/>
          <span >{gt.name}</span>
        </label>
      ))}
  </div>
);

export default GraphTypes;
